/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import deepmerge from 'deepmerge';

export { default as deepmerge } from 'deepmerge';

const mergeOptions = {
  arrayMerge: (target: any, source: any, options: any) => {
    const destination = target.slice();

    source.forEach((item: any, index: number) => {
      if (typeof destination[index] === 'undefined') {
        destination[index] = options.cloneUnlessOtherwiseSpecified(
          item,
          options
        );
      } else if (options.isMergeableObject(item)) {
        destination[index] = deepmerge(target[index], item, options);
      } else if (target.indexOf(item) === -1) {
        destination.push(item);
      }
    });
    return destination;
  },
};

export function merge<T>(
  prev: T,
  next?: { [key: string]: any }
) {
  if (!next) return prev;

  return deepmerge<T, { [key: string]: any }>(
    prev,
    next,
    mergeOptions
  );
}
